const val = (field) => (field && typeof field === 'object' ? (field.value ?? '') : (field ?? ''))

export function buildEyeMedContactLensesPayload(contactLens = {}) {
  if (!contactLens || typeof contactLens !== 'object') return {}
  if (contactLens.diagnosis_code !== undefined && typeof contactLens.medically_necessary !== 'object') {
    const { attachments_attributes: _omit, ...rest } = contactLens
    return rest
  }

  const medicallyNecessary = val(contactLens.medically_necessary)
  const defaultDiagnosis = val(contactLens.default_diagnosis)
  const diagnosis = medicallyNecessary === 'Yes'
    ? val(contactLens.medically_necessary_diagnosis_code)
    : defaultDiagnosis

  return {
    medically_necessary: medicallyNecessary,
    procedure_code: val(contactLens.medically_necessary_procedure_code),
    diagnosis_code: diagnosis ? [diagnosis] : [],
    disposable: val(contactLens['disposable_contacts/planned_replacement?']),
    manufacturer: val(contactLens.manufacturer),
    brand: val(contactLens.brand),
    modality: val(contactLens.modality),
    boxes: String(val(contactLens.number_of_boxes) || ''),
    material: val(contactLens.material),
    supplies: val(contactLens['contact_lens_supplies?']),
    other_diagnosis: String(val(contactLens['other_disease(specify_icd_codes_separated_by_a_comma)']) || ''),
    default_diagnosis: defaultDiagnosis,
    signers_name: val(contactLens.signers_name),
  }
}

export function normalizeEyeMedContactLensesForForm(contactLenses = {}, attachments = []) {
  if (contactLenses?.medically_necessary?.value !== undefined) return contactLenses

  const diagnosis = (contactLenses.diagnosis_code || [])[0] || ''

  return {
    medically_necessary: { value: contactLenses.medically_necessary || '' },
    medically_necessary_procedure_code: { value: contactLenses.procedure_code || '' },
    medically_necessary_diagnosis_code: { value: contactLenses.medically_necessary === 'Yes' ? diagnosis : '' },
    default_diagnosis: { value: contactLenses.default_diagnosis || (contactLenses.medically_necessary !== 'Yes' ? diagnosis : '') },
    'disposable_contacts/planned_replacement?': { value: contactLenses.disposable || '' },
    manufacturer: { value: contactLenses.manufacturer || '' },
    brand: { value: contactLenses.brand || '' },
    modality: { value: contactLenses.modality || '' },
    number_of_boxes: contactLenses.boxes || '',
    material: { value: contactLenses.material || '' },
    'contact_lens_supplies?': { value: contactLenses.supplies || '' },
    'other_disease(specify_icd_codes_separated_by_a_comma)': contactLenses.other_diagnosis || '',
    signers_name: contactLenses.signers_name || '',
    attachments_attributes: (attachments || []).filter((item) => !item._destroy && String(item.metadata || '').startsWith('contact_lenses')),
  }
}
